import { fakeI18n } from "@/i18n";
import { StaticTablePath } from "@/shared/apis/staticTablePath";

export type RefType =
    | "yesNo"
    | "gender"
    | "country"
    | "nationality"
    | "language"
    | "taxStatus"
    | "taxStatusMoral"
    | "personTitle"
    | "legalStatus"
    | "relationType"
    | "maritalStatus"
    | "socialStatuses"
    | "phoneNumberType"
    | "bankAccountType"
    | "driversLicenseType"
    | "additionalTaxStatus"
    | "personTitleSchoolClaim"
    | "brokenGlasses"
    | "nature"
    | "damageType"
    | "place"
    | "architectType"
    | "emailType"
    | "addressType"
    | "vehicleDocument"
    | "vehicleClaimResponsibility"
    | "vehiclePowerType"
    | "vehicleFuelType"
    | "vehicleUsage"
    | "vehicleType"
    | "workNature";

type StaticTableInfo = {
    label: string;
    path: StaticTablePath;
};

type StaticTables = {
    [x in RefType]: StaticTableInfo;
};

export const staticTables: Readonly<StaticTables> = Object.freeze({
    gender: { path: StaticTablePath.Gender, label: fakeI18n.t("Common.Gender") },
    country: { path: StaticTablePath.Country, label: fakeI18n.t("Common.Country") },
    nationality: { path: StaticTablePath.Nationality, label: fakeI18n.t("Common.Nationality") },
    language: { path: StaticTablePath.Languages, label: fakeI18n.t("Common.Languages") },
    taxStatus: { path: StaticTablePath.TaxStatus, label: fakeI18n.t("Common.FiscalStatus") },
    taxStatusMoral: { path: StaticTablePath.TaxStatusMoral, label: fakeI18n.t("Common.FiscalStatus") },
    personTitle: { path: StaticTablePath.PersonTitle, label: fakeI18n.t("Common.Title") },
    legalStatus: { path: StaticTablePath.LegalStatus, label: fakeI18n.t("Common.LegalStatus") },
    relationType: { path: StaticTablePath.RelationType, label: fakeI18n.t("Common.RelationType") },
    maritalStatus: { path: StaticTablePath.MaritalStatus, label: fakeI18n.t("Common.CivilStatus") },
    socialStatuses: { path: StaticTablePath.SocialStatus, label: fakeI18n.t("Common.SocialStatus") },
    phoneNumberType: { path: StaticTablePath.PhoneNumberType, label: "" },
    bankAccountType: { path: StaticTablePath.BankAccountType, label: fakeI18n.t("Common.AccountType") },
    driversLicenseType: { path: StaticTablePath.DriverLicenseType, label: fakeI18n.t("Common.Type") },
    additionalTaxStatus: { path: StaticTablePath.AdditionalTaxStatus, label: fakeI18n.t("Common.AdditionalTaxStatus") },
    personTitleSchoolClaim: { path: StaticTablePath.PersonTitleSchool, label: fakeI18n.t("Common.Title") },
    brokenGlasses: { path: StaticTablePath.BrokenGlasses, label: fakeI18n.t("Common.BrokenGlasses") },
    nature: { path: StaticTablePath.Nature, label: fakeI18n.t("Common.Nature") },
    damageType: { path: StaticTablePath.DamageType, label: fakeI18n.t("Common.DamageType") },
    place: { path: StaticTablePath.Place, label: fakeI18n.t("Common.Place") },
    architectType: { path: StaticTablePath.ArchitectType, label: fakeI18n.t("Common.Person") },
    emailType: { path: StaticTablePath.EmailType, label: "" },
    workNature: { path: StaticTablePath.WorkNature, label: "" },
    addressType: { path: StaticTablePath.AddressType, label: "" },
    vehicleDocument: { path: StaticTablePath.VehicleDocuments, label: fakeI18n.t("Common.Type") },
    vehicleClaimResponsibility: {
        path: StaticTablePath.VehicleClaimLiabilityResponsibility,
        label: fakeI18n.t("Common.Responsibility"),
    },
    vehiclePowerType: { path: StaticTablePath.VehiclePowerType, label: "" },
    vehicleFuelType: { path: StaticTablePath.VehicleFuelType, label: fakeI18n.t("Common.Fuel") },
    vehicleUsage: { path: StaticTablePath.VehicleUsages, label: fakeI18n.t("Common.Usage") },
    vehicleType: { path: StaticTablePath.VehicleType, label: fakeI18n.t("Common.Type") },
    yesNo: { path: StaticTablePath.YesNo, label: "" },
});
